export const SCORECARD_UPLOAD_SUPPORTED_FORMATS = {
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
};
export const CLIENT_UPLOAD_SUPPORTED_FORMATS = {
  "text/csv": [".csv"],
};
export const MAX_FILE_SIZE = 35 * 1024 * 1024;



// WEBPACK FOOTER //
// ./src/features/score-card/constants/formValidations.js